'use strict';

var kleber = require('./kleberCommon.js');
var kleberAddressSearch = require('./kleberAddressSearch.js');


var KLEBER_METHODS = {
    AU: {
        repairAddress: 'DataTools.Repair.Address.AuPaf.RepairAddress'
    }
};

var kleberConfigs = window.kleberConfigs;
var isProductionInstance = kleberConfigs.isProductionInstance;
var KLEBER_REQUEST_URL;

if (isProductionInstance) {
    KLEBER_REQUEST_URL = 'https://kleber.datatoolscloud.net.au/KleberWebService/DtKleberService.svc/ProcessQueryStringRequest';
} else {
    KLEBER_REQUEST_URL = 'https://kleber-devuat.datatoolscloud.net.au/KleberWebService/DtKleberService.svc/ProcessQueryStringRequest';
}

/**
 * Checks if address search is enabled for address book
 * @returns {boolean} - Address search enabled for address book
 */
 function isKleberAddressRepairEnabled() {
    if (kleberConfigs && kleberConfigs.isKleberAddressRepairEnabled && kleberConfigs.isKleberAddressSearchEnabled) {
        return kleberConfigs.isKleberAddressRepairEnabled;
    }
    return false;
}

/**
 * To create kleber popup
 * @param {Object} addressFieldValues address form fields
 * @param {string} updatedAddress address updated by customer
 * @param {string} verificationMsg verification message
 * @param {string} formType form type
 */
 function initKleberPopup(addressFieldValues, updatedAddress, verificationMsg, formType) {
    var address = addressFieldValues.address1 + ' ' + addressFieldValues.stateCode + ' ' + addressFieldValues.postalCode;

    if (verificationMsg === 'valid') {
        if ($('#kleberpopup-dialog')) {
            $('.valid-address').show();
            $('.invalid-address').hide();
            $('.valid-address .suggestedAddress').empty();
            $('<span>' + address + '</span>').appendTo('.valid-address .suggestedAddress');
            $('#kleberpopup-dialog').modal('show');
        }
        $('#kleberpopup-dialog .use-suggested-address').off('click').on('click', function () {
            if (formType === 'addressBook') {
                kleberAddressSearch.populateAddressBookForm(addressFieldValues);
                $('#kleberpopup-dialog').modal('hide');
                $('body').trigger('repairAddress:success');
            }
            if (formType === 'shipping') {
                window.sessionStorage.setItem('invalidAddress', 'false');
                kleberAddressSearch.populateShippingAddressForm(addressFieldValues);
                $('#kleberpopup-dialog').modal('hide');
                $('.shipping-method-list').trigger('change');
            }
        });
        $('#kleberpopup-dialog .use-original-address').off('click').on('click', function (event) {
            $('#kleberpopup-dialog').modal('hide');
            if (formType === 'addressBook') {
                $('body').trigger('repairAddress:success');
            }
            if (formType === 'shipping') {
                window.sessionStorage.setItem('invalidAddress', 'false');
                kleberAddressSearch.populateShippingAddressForm(updatedAddress);
                $('body').trigger('repairShippingAddress:success');
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
             }
        });
    } else {
        if ($('#kleberpopup-dialog')) {
            $('.valid-address').hide();
            $('.invalid-address').show();
            $('.invalid-address .wrongAddress').empty();
            $('<span>' + address + '</span>').appendTo('.invalid-address .wrongAddress');
            $('#kleberpopup-dialog').modal('show');
        }
        $('#kleberpopup-dialog .edit-address').off('click').on('click', function () {
            $('#kleberpopup-dialog').modal('hide');
        });
        $('#kleberpopup-dialog .use-invalid-address').off('click').on('click', function (event) {
            $('#kleberpopup-dialog').modal('hide');
            if (formType === 'addressBook') {
                $('body').trigger('repairAddress:success');
            }
            if (formType === 'shipping') {
                window.sessionStorage.setItem('invalidAddress', 'true');
                $('body').trigger('repairShippingAddress:success');
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
            }
        });
    }
}

/**
 * @param {string} form form element
 * @param {string} fmType formType
 */
 function kleberRepairAddress(form, fmType) {
        var formType = fmType;
        if (isKleberAddressRepairEnabled()) {
            var $form = $(form);
            var isEditAddressPage;
    
            if (formType === 'addressBook') {
                isEditAddressPage = ($('.page').attr('data-action') === 'Address-EditAddress') && ($form.find('input#shippingAddressOne').attr('data-value') === '');
            } else if (formType === 'shipping') {
                isEditAddressPage = ($form.find('input#shippingAddressOne').attr('value') !== '') && ($form.find('input#shippingAddressOne').attr('data-value') === '');
            }
    
            var addr1 = $form.find('input#shippingAddressOne');
            var addr2 = $form.find('input#shippingAddressTwo');
            var locality = $form.find('input#shippingAddressCity');
            var state = $form.find('select#shippingState');
            var zip = $form.find('input#shippingZipCode');
            var dataAddr1 = isEditAddressPage ? $form.find('input#shippingAddressOne').attr('value') : $form.find('input#shippingAddressOne').attr('data-value');
            var dataAddr2 = isEditAddressPage ? $form.find('input#shippingAddressTwo').attr('value') : $form.find('input#shippingAddressTwo').attr('data-value');
            var dataLocality = isEditAddressPage ? $form.find('input#shippingAddressCity').attr('value') : $form.find('input#shippingAddressCity').attr('data-value');
            var dataState = isEditAddressPage ? $form.find('select#shippingState').children('option:selected').attr('value') : $form.find('select#shippingState').attr('data-value');
            var dataZipVal = isEditAddressPage ? $form.find('input#shippingZipCode').attr('value') : $form.find('input#shippingZipCode').attr('data-value');
            var dataZip = dataZipVal ? dataZipVal.toString() : undefined;
    
            var manualAddress = {
                address1: $(addr1).val(),
                address2: $(addr2).val(),
                city: $(locality).val(),
                postalCode: $(zip).val(),
                stateCode: $(state).val()
            };
        
            var kleberAddress = {
                address1: dataAddr1,
                address2: dataAddr2,
                city: dataLocality,
                postalCode: dataZip,
                stateCode: dataState
            };
            var addressModified = (JSON.stringify(manualAddress) !== JSON.stringify(kleberAddress));
            
            if (formType === 'shipping') {
                var invalidAddress = window.sessionStorage.getItem('invalidAddress');
                if (invalidAddress === 'true') {
                    addressModified = true;
                }
            }
        
            if (addressModified) {
                kleber.getTemporaryAccessKey().then((kleberTemporaryAccessKey) => {
                    $.ajax({
                        url: KLEBER_REQUEST_URL,
                        dataType: 'jsonp',
                        type: 'GET',
                        contentType: 'application/json; charset=utf-8',
                        data: {
                            Method: KLEBER_METHODS.AU.repairAddress,
                            Country: 'AU',
                            AddressLine1: $(addr1).val(),
                            AddressLine2: ($(addr2).val()),
                            Locality: $(locality).val(),
                            State: $(state).val(),
                            Postcode: $(zip).val(),
                            RequestKey: kleberTemporaryAccessKey,
                            OutputFormat: 'json'
                        },
                        success: function (data) {
                            if (data.DtResponse.Result && data.DtResponse.Result.length > 0) {
                                if (data.DtResponse.Result[0].MatchType === '0') {
                                    var addressFieldValues = kleberAddressSearch.parseKleberRetrieveAddressResponse(data.DtResponse.Result, 'AU');
                                    initKleberPopup(addressFieldValues, manualAddress, 'valid', formType);
                                } else {
                                    initKleberPopup(manualAddress, null, 'invalid', formType);
                                }
                            }
                        }
                    });
                });
            } else if (formType === 'addressBook') {
                $('body').trigger('repairAddress:success');
            } else if (formType === 'shipping') {
                $('body').trigger('repairShippingAddress:success');
            }
        } else if (formType === 'addressBook') {
            $('body').trigger('repairAddress:success');
        } else if (formType === 'shipping') {
            $('body').trigger('repairShippingAddress:success');
        }
    }

module.exports = {
    repairAddress: kleberRepairAddress
};
